import { Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const BlockTitle = styled(Typography).attrs({
  as: "h3",
  color: "black",
  fontSize: 18,
  mb: { _: 3, tablet: 5 },
})`
  background-image: linear-gradient(transparent, #313131);
  background-position: bottom left;
  background-repeat: no-repeat;
  background-size: 105px 1px;
  padding-bottom: 8px;
  ${(props) =>
    props.center &&
    `
    background-position: bottom center;
    text-align: center;
  `}
`

export const Text = styled(Typography).attrs((props) => ({
  color: "black",
  display: "block",
  fontWeight: "300",
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  ...props,
}))``
